import { isAfter, isBefore, isSameDay, parseISO } from 'date-fns';
import { Map } from 'immutable';
import { createSelector } from 'reselect';

import { selectLightFixtures } from '@sophocles/features/reference';

export const relayLoadSelector = state => state.entities.relayLoads;

export const selectRelayLoadById = (state, id) => relayLoadSelector(state).get(id.toString(), Map());

export function addLightFixtureToRelayLoads(relayLoads) {
  return createSelector(relayLoads, selectLightFixtures, (loads, fixtures) => {
    // Build an id-keyed lookup so downstream billboard Immutable .getIn() calls work.
    const fixtureById = fixtures.reduce((acc, f) => {
      acc[f.id] = Map(f);
      return acc;
    }, {});
    return loads.map(load => {
      const fixtureId = parseInt(load.get('fixture', '0') ?? '0', 10);
      return load.set('fixture', fixtureById[fixtureId] ?? Map());
    });
  });
}

export function addRelayLoadContractsToRelayLoads(loadSelector, contractSelector) {
  return createSelector(loadSelector, contractSelector, (loads, contracts) => {
    if (loads.isEmpty()) {
      return loads;
    } // breakout
    let newLoads = loads;
    const today = new Date();
    contracts.forEach(contract => {
      const start = contract.get('contract_start', null);
      const end = contract.get('contract_end', null);

      const startDate = start ? parseISO(start) : null;
      const endDate = end ? parseISO(end) : null;

      if (
        startDate &&
        endDate &&
        (isSameDay(startDate, today) || isBefore(startDate, today)) &&
        (isSameDay(endDate, today) || isAfter(endDate, today))
      ) {
        const relay_id = contract.get('relay_load', '0').toString();
        newLoads = newLoads.setIn([relay_id, 'contract'], contract);
      }
    });
    return newLoads;
  });
}
